import { formatDistanceToNow } from "date-fns";

export const parseCampaignDate = (value) => {
  if (!value) return null;
  const raw = String(value).trim();
  const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
};

const notificationTitle = (item) =>
  (item?.description_array || [])
    .map((part) => (part?.text || "").trim())
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

export const campaignToNotification = (issue) => {
  const date = parseCampaignDate(issue.published_at);
  const timeAgo = date
    ? formatDistanceToNow(date, { addSuffix: true }).replace(/^about /, "")
    : "";

  return {
    type: "notification",
    category: "email",
    active: false,
    createdAt: date ? date.toISOString() : issue.published_at,
    time_ago: timeAgo,
    description_array: [{ text: issue.title }],
    querystring: `/newsletter?issue=${encodeURIComponent(issue.id)}`,
    newsletterIssueId: String(issue.id),
  };
};

export const mergeNewsletterNotifications = (notifications, issues) => {
  const rows = (notifications || []).filter(
    (item) => item && item.type === "notification"
  );
  const titles = new Set(rows.map(notificationTitle).filter(Boolean));
  const seenIssueIds = new Set(
    rows.map((item) => item.newsletterIssueId).filter(Boolean)
  );

  const extras = [];
  (issues || []).forEach((issue) => {
    const title = (issue?.title || "").trim();
    const id = issue?.id ? String(issue.id) : "";
    if (!id || !title || titles.has(title.toLowerCase()) || seenIssueIds.has(id)) {
      return;
    }
    titles.add(title.toLowerCase());
    seenIssueIds.add(id);
    extras.push(campaignToNotification(issue));
  });

  return [...rows, ...extras].sort((a, b) => {
    const aTime = new Date(a.createdAt).getTime() || 0;
    const bTime = new Date(b.createdAt).getTime() || 0;
    return bTime - aTime;
  });
};
